module.exports = __webpack_public_path__ + "img/CE.fd4a074e.png";